
/*
form is where we have all the details for all the inputs
for the entity  forms
each entity has their own form
*/

const {states} = require ('../../../../../js-handler/library/states') 

export const form   =  [
	{	
		name: "code", 
		value:'', 		
		id:'clientSale_form_code',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "customer_id", 
		value:[], 	//just the id	
		valueFull:'',
		id:'clientSale_form_customer_id',
		html:'',
		type:'autocomplete',
		required: true,  
	},
	{	
		name: "sale_date", 
		value:'0000-00-00',
		date: true, 		
		id:'clientSale_form_clientSale_date',
		html:'',
		type:'textfield',
		required: true,  
	},
	{	
		name: "due_date", 
		value:'0000-00-00',
		date: true, 		
		id:'clientSale_form_due_date',
		html:'',
		type:'textfield',
		required: true,  
	},
	{	
		name: "printed_note", 
		value:'',
		id:'clientSale_printed_note',
		html:'',
		type:'textfield',
		required: false,  
	},
	
	
	
	
	
	{	
		name: "grand_total", 
		value:'', 		
		id:'clientSale_form_grand_total',
		html:'',
		type:'textfield',
		required: false,  
	},
	
	{	
		name: "shipping_status", 
		value:'', 		
		id:'clientSale_form_shipping_status',
		html:'',
		type:'multiselect',
		options :[{value:'preparing', text:'Preparing'}, {value:'shipped', text:'Shipped'},
				  {value:'delivered', text:'Delivered'}, {value:'ready to pickup', text:'Ready To Pickup'}], 
		required: false, 
	},
	{	
		name: "terms", 
		value:'', 		
		id:'clientSale_form_terms',
		html:'',
		type:'multiselect',
		options :[{value:'15', text:'15 days'}, {value:'21', text:'21 days'},
				  {value:'30', text:'30 days'}], 
		required: false, 
	},
	
	
]



//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form))